import { useEffect } from 'react';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { noop } from '@src/utils/common-util';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import Video from '@src/components/video';
import { getBackgroundMusic } from '@src/components/audio';
import Message from '@src/components/common-message';
import TabMenuStore from '../components/tab-menu/store';
import { mechaData } from './mechaUnit';

const pageLocalesData = getPageLocalesData();
const styles = require('./index.less');
const lang = getLanguageByPath();

class MechaUnitStore extends BaseStore {
  tabMenuStore = new TabMenuStore({
    currentMechaId: 'alpha'
  });
  @observable isActive = false;
  closeVideoModal = noop; // 关闭视频弹窗

  @observable pageData;
  // 语音TAB
  @observable cvTab;
  // cv数据
  @observable cvList;
  // 当前cv音频
  @observable currentCvAudio;
  // 语音当前播放的角标
  @observable cvIndex;
  // 当前音频是否播放
  @observable currentAudioState;
  // 语音tab角标
  @observable cvTabIndex = 0;
  // 机甲信息
  @observable mechaCmsData = null;

  // 切换语音tab
  switchCvTab(i, langType) {
    this.cvTabIndex = i;
    if (langType === 'ch') {
      this.cvList = mechaData.zhCvList;
    } else if (langType === 'en') {
      this.cvList = mechaData.enCvList;
    } else {
      this.cvList = mechaData.jaCvList;
    }
    this.bgmAudio && this.bgmAudio.stop();
  }
  // 点击播放音频
  onClickPlayRoleAudio(index) {
    this.cvIndex = index;
    this.cvList.forEach((cv, i) => {
      if (i !== index && cv.isPlay) {
        // 如果是其他项正在播放，则暂停它
        cv.isPlay = false;
      }
    });

    // 2. 切换当前点击项的播放状态
    this.cvList[index].isPlay = !this.cvList[index].isPlay;

    if (this.cvList[index].isPlay) {
      // 播放音频
      if (this.cvList[index].cvAudio_url === '') {
        return Message.info(`${pageLocalesData.global.comming_soon}`);
      }
      if (!this.bgmAudio) {
        this.bgmAudio = getBackgroundMusic({
          loop: false,
          endedCb: this.onResetAudioState
        });
      }
      this.currentCvAudio = this.cvList[index].cvAudio_url;
      this.bgmAudio.audio.src = this.currentCvAudio;
      this.bgmAudio && this.bgmAudio.play();
      this.currentAudioState = true;
    } else {
      this.currentAudioState = false;
      this.bgmAudio.stop();
    }
  }
  // 播放弹窗视频
  playVideo = () => {
    const videoUrl = this.mechaCmsData?.videoUrl;
    if (!videoUrl) {
      Message.info(getLocales('global.comming_soon'));
      return;
    }
    const { close } = Video.append({
      src: videoUrl,
      borderColor: '#1be4d0',
      modalContainerClassName: styles.modalContainerClassName
    });
    this.closeVideoModal = close;
  };
  // 重置音频状态
  onResetAudioState = () => {
    if (this.cvList[this.cvIndex]) {
      this.cvList[this.cvIndex].isPlay = false;
      this.currentAudioState = false;
    }
  };

  use() {
    super.use();

    useEffect(
      () => {
        if (this.cvList) {
          this.bgmAudio && this.bgmAudio.stop();
          this.onResetAudioState();
        }
      },
      [this.currentIndex, this.cvTabIndex]
    );

    useMount(() => {
      this.isActive = true;
      // 获取语音数据
      if (lang === 'ja') {
        this.cvList = mechaData.jaCvList;
        this.cvTab = [
          {
            name: mechaData.cvJA,
            langType: 'ja',
            lang: pageLocalesData.mechaUnit.voiceTabJA
          },
          {
            name: mechaData.cvEN,
            langType: 'en',
            lang: pageLocalesData.mechaUnit.voiceTabEN
          },
          {
            name: mechaData.cvCH,
            langType: 'ch',
            lang: pageLocalesData.mechaUnit.voiceTabCH
          }
        ];
      } else {
        this.cvList = mechaData.enCvList;
        this.cvTab = [
          {
            name: mechaData.cvEN,
            langType: 'en',
            lang: pageLocalesData.mechaUnit.voiceTabEN
          },
          {
            name: mechaData.cvJA,
            langType: 'ja',
            lang: pageLocalesData.mechaUnit.voiceTabJA
          },
          {
            name: mechaData.cvCH,
            langType: 'ch',
            lang: pageLocalesData.mechaUnit.voiceTabCH
          }
        ];
      }
    });
  }
}

export default MechaUnitStore;
